import {
  APIConnectionConfig,
  ModuleConfig,
  ModuleDisplayConfig,
  ModuleMapConfig,
} from '@schamburg-web/interfaces';
import CameraPopupCard from './CameraPopupCard';
import CameraMarker from './CameraMarker';
import CameraSideBarCard from './CameraSideBarCard';
import { cameraClusterRenderer } from './utils';
import { getLocationDescription, getNormalizedIcon } from '../utils';

export const cameraIcon = '/mapicons/camera.svg';
export const cameraOutIcon = '/mapicons/cameraout.svg';

const sidebarSort = (a: any, b: any): number => {
  // Sort by location description with natural sorting for numbers
  const aNormalized = getNormalizedIcon(a);
  const bNormalized = getNormalizedIcon(b);
  const aLocation = getLocationDescription(aNormalized);
  const bLocation = getLocationDescription(bNormalized);

  // Use localeCompare with numeric option for natural sorting
  return aLocation.localeCompare(bLocation, undefined, {
    numeric: true,
    sensitivity: 'base',
  });
};

const mapModuleConfig: ModuleMapConfig = {
  zIndex: 70,
  layerIcon: cameraIcon,
  showOnMap: true,
  defaultEnabled: false,
  clusterLayer: true,
  clusterLayerOptions: {
    maxZoom: 10, // Maximum zoom level for clustering
    renderer: cameraClusterRenderer,
  }, // Custom renderer for MarkerClusterer
};

const displayConfig: ModuleDisplayConfig = {
  label: 'Camera #',
  isPopupDialog: true,
  isOnSideBar: true,
  popupDef: CameraPopupCard,
  cardDef: CameraSideBarCard,
  markerDef: CameraMarker,
  sidebarSort: sidebarSort,
};

const apiConfig: APIConnectionConfig = {
  endpoint: 'cctv',
  updateDelay: 0,
  publishLayer: 'cctv',
  useFakeData: false, // Set to true for development purposes
};

const moduleConfig: ModuleConfig = {
  moduleLabel: 'Cameras',
  name: 'camera',
  mapConfig: mapModuleConfig,
  displayConfig: displayConfig,
  apiConfig: apiConfig,
};

export default moduleConfig;
